import { render } from "./AvailableAcceptanceDialog.vue?vue&type=template&id=4061b967&scoped=true"
import script from "./AvailableAcceptanceDialog.vue?vue&type=script&lang=ts"
export * from "./AvailableAcceptanceDialog.vue?vue&type=script&lang=ts"

import "./AvailableAcceptanceDialog.vue?vue&type=style&index=0&id=4061b967&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4061b967"

export default script